import React, {useEffect} from 'react';
import ReactPixel from 'react-facebook-pixel';
import {useSelector} from "react-redux";
import {store} from "@arboxappv4/shared/src/redux/store";
import { useLocation } from 'react-router-dom';

const options = {
    autoConfig: true,
    debug: true, // Set to true to see console logs, TURN ON ONLY ON LOCAL ENV DEBUG
    testEvents: true // TURN ON ONLY ON LOCAL ENV DEBUG
};

export const pixelEvents = {
    PURCHASE: 'Purchase',
    ADD_TO_CART: 'AddToCart',
    LEAD: 'Lead',
    VIEW_CONTENT: 'ViewContent',
    COMPLETE_REGISTRATION_NO_MEMBERSHIP: 'CompleteRegistration'
}

export const sendPixelEvent = (eventName, data = {}) => {
    try {
        const box = store.getState().site.box
        console.log('sendPixelEvent', eventName, data)
        const globalLocation = store.getState().site.selectedLocation

        const eventData = {
            currency: globalLocation.currency,
            ...data
        };

        if (box?.facebook_pixel_id) {
            ReactPixel.track(eventName, {
                ...eventData,
                test_event_code: 'TEST94283', //my local test, wouldn't work anywhere else, each pixel has it's own test_event_code
            });
        }
        if(box?.tiktok_pixel_id && window.ttq) {
            window.ttq.track(eventName, {
                ...eventData,
                test_event_code: 'TEST65907', //my local test, wouldn't work anywhere else, each pixel has it's own test_event_code
            });
        }

    } catch (e) {
        console.log('error sending pixel event', e, eventName, data)
    }
}

const UsePixel = () => {
    const box = useSelector(state => state.site.box)
    const location = useLocation();

    useEffect(() => {
        if(box?.facebook_pixel_id) {
            initFacebookPixel(box.facebook_pixel_id)
        }
        if(box?.tiktok_pixel_id) {
            initTikTokPixel(box.tiktok_pixel_id)
        }
    }, [box]);

    useEffect(() => {
        if (box?.facebook_pixel_id) {
            ReactPixel.pageView();
        }
    }, [location.pathname, box?.facebook_pixel_id]);

    const initFacebookPixel = (pixelID) => {
        console.log('initFacebookPixel', pixelID)
        ReactPixel.init(pixelID, undefined, options);
    };

    const initTikTokPixel = (pixelID) => {
        if (typeof window === 'undefined') return;

        if (!document.getElementById('ttq-script')) {
            const script = document.createElement('script');
            script.id = 'ttq-script';
            script.innerHTML = `
      !function (w, d, t) { 
        w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for( var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script") ;n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
      }(window, document, 'ttq');
    `;
            document.head.appendChild(script);
        }

        window.ttq.load(pixelID);
        window.ttq.page();
    };
};

export default UsePixel;